export default __webpack_public_path__ + "static/media/AlgebraTableImg3.3eb9ceed.PNG";